export function completionLabel(state?: string | null): string {
  const labels: Record<string, string> = {
    concluded: 'Clear conclusion', retry_scheduled: 'Retry / callback scheduled',
    retry_exhausted: 'Attempts exhausted · review needed', needs_review: 'Team follow-up needed',
    retry_blocked: 'Retry blocked by contact preference', unverified: 'Outcome unverified · older call',
    in_progress: 'Call in progress', test_only: 'Test call · no production retry',
  };
  return labels[state || ''] || 'Outcome unverified';
}
